import {SafetyMoveTaskProps} from "./SafetyPlay";
import {DndProvider, useDrag, useDrop} from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import React, {useEffect, useRef} from "react";

interface MoveDragObject {
    id: number
    isCorrect: boolean
}

const MoveDragObjectType = 'move-drag-item'

const MoveItem = ( { id, src, isCorrect, isDroppedCorrectly, solve } ) => {
    const ref = useRef(null);

    const [, connectDrag] = useDrag({
        item: { id: id, isCorrect: isCorrect },
        type: MoveDragObjectType,
        canDrag: isDroppedCorrectly === undefined,
    })

    connectDrag(ref)

    return <div ref={ref} className={"item" + (solve ? (isCorrect ? " correct" : " wrong") : "") + (isDroppedCorrectly !== undefined ? (isDroppedCorrectly ? " correct" : " wrong") : "")}><img src={src} alt="drag item" /></div>
}

const DropItem = ( { isCorrect, onDrop } ) => {
    const ref = useRef(null);

    const [, connectDrop] = useDrop({
        accept: MoveDragObjectType,
        drop(dragObject) {
            onDrop(dragObject as MoveDragObject)
        },
    })

    connectDrop(ref)

    return <img ref={ref} className={ isCorrect ? "correct" : "wrong" } src={"images/safety/" + (isCorrect ? "correct" : "incorrect") + "-circle.png"} alt="" />
}


export default function SafetyMove(props: SafetyMoveTaskProps) {

    const processItem = (item: MoveDragObject, toCorrect: boolean) => {
        props.onItemDropped(item.id, props.onItemDragged(item.id, item.isCorrect, toCorrect))
    }

    const isDroppedCorrectly = (index: number) => {
        if (props.droppedCorrectly.indexOf(index) !== -1) {
            return true
        } else if (props.droppedIncorrectly.indexOf(index) !== -1) {
            return false
        }
    }

    useEffect(() => {
        props.onLoaded()
    }, [])

    return <DndProvider backend={HTML5Backend}>
        <div className={"drag-container"}>
            <img className={"background"} src={"images/safety/move-background.png"} alt="background" />
            <DropItem isCorrect={true} onDrop={(item) => processItem(item, true) } />
            <DropItem isCorrect={false} onDrop={(item) => processItem(item, false) } />
            <div className={"items"}>
                { props.task.answers.slice(0, 5).map((answer, index) =>
                    <MoveItem id={index} key={index} src={answer.picture} isCorrect={answer.correct} isDroppedCorrectly={isDroppedCorrectly(index)} solve={props.solve} />
                )}
            </div>
        </div>
    </DndProvider>
}